/**
 * BitMiner24 — Motion FX
 * Small decoration layer without an animation library. Scroll reveals live in
 * CSS (bm-modern.css, scroll-driven animations); this file only keeps what CSS
 * cannot do on its own.
 *
 * Every helper degrades to "no effect": content is never hidden, text is never
 * replaced by placeholder values, and reduced motion turns everything off.
 *
 * Exposed as window.BMFx. Tested in BitMiner-Theme/tests/bm-motion-fx.test.cjs.
 */
(function (window, document) {
  'use strict';

  function prefersReduced() {
    try { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (e) { return false; }
  }

  /**
   * Sets an element's text. Kept under its old name for the live-data call
   * sites (btc-reward-live, live banner, solo tracker). Returns true when the
   * displayed text changed, so callers can flash only on real updates.
   */
  function tweenText(el, newText) {
    if (!el || typeof newText !== 'string') return false;
    if (el.textContent === newText) return false;
    el.textContent = newText;
    return true;
  }

  /** Short attention tick (scale pulse) via the Web Animations API. */
  function flash(el) {
    if (!el || prefersReduced() || typeof el.animate !== 'function') return;
    try {
      // transform needs a box; only promote true inline elements, never flex/grid buttons
      if (window.getComputedStyle && getComputedStyle(el).display === 'inline') {
        el.style.display = 'inline-block';
      }
      el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }],
        { duration: 500, easing: 'ease-out' }
      );
    } catch (e) {}
  }

  /** Relative time for whole days; the implementation lives in bm-format.js. */
  function daysAgoText(days) {
    return window.BMFormat ? window.BMFormat.daysAgo(days) : String(days);
  }

  // --- spotlight cards + CTA shimmer (injected children) ----------------------

  // Styles live here (not in theme CSS) so removing this file removes the FX.
  // Child <span>s instead of ::after: theme buttons and cards already use pseudos.
  function injectStyles() {
    if (!document || document.getElementById('bm-fx-style')) return;
    var css = '' +
      '[data-bm-spotlight]{position:relative}' +
      '.bm-fx-spot{position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:3;opacity:0;transition:opacity .25s ease;background:radial-gradient(320px circle at var(--bm-spot-x,50%) var(--bm-spot-y,50%),rgba(247,147,26,.12),transparent 65%)}' +
      '[data-bm-spotlight]:hover .bm-fx-spot{opacity:1}' +
      '[data-bm-shimmer]{position:relative;overflow:hidden}' +
      // transform-only keyframes: animating `left` would force layout every frame
      '.bm-fx-shimmer{position:absolute;top:-20%;bottom:-20%;left:0;width:50%;pointer-events:none;background:linear-gradient(105deg,transparent 20%,rgba(255,255,255,.28) 50%,transparent 80%);transform:translateX(-170%) skewX(-18deg);animation:bm-fx-shimmer 6s ease-in-out infinite}' +
      '@keyframes bm-fx-shimmer{0%,72%{transform:translateX(-170%) skewX(-18deg)}88%,100%{transform:translateX(270%) skewX(-18deg)}}' +
      '@media (prefers-reduced-motion: reduce){.bm-fx-shimmer,.bm-fx-spot{display:none}}';
    var s = document.createElement('style');
    s.id = 'bm-fx-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function initSpotlights() {
    if (!document || prefersReduced()) return;
    var mq;
    try { mq = window.matchMedia('(hover: hover) and (pointer: fine)'); } catch (e) { return; }
    if (!mq || !mq.matches) return;
    var cards = document.querySelectorAll('[data-bm-spotlight]');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.querySelector('.bm-fx-spot')) return;
      var spot = document.createElement('span');
      spot.className = 'bm-fx-spot';
      spot.setAttribute('aria-hidden', 'true');
      card.appendChild(spot);
      var pending = false, lastX = 0, lastY = 0;
      card.addEventListener('mousemove', function (e) {
        lastX = e.clientX; lastY = e.clientY;
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          var r = card.getBoundingClientRect();
          card.style.setProperty('--bm-spot-x', (lastX - r.left) + 'px');
          card.style.setProperty('--bm-spot-y', (lastY - r.top) + 'px');
        });
      }, { passive: true });
    });
  }

  function initShimmers() {
    if (!document || prefersReduced()) return;
    var els = document.querySelectorAll('[data-bm-shimmer]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.querySelector('.bm-fx-shimmer')) return;
      var bar = document.createElement('span');
      bar.className = 'bm-fx-shimmer';
      bar.setAttribute('aria-hidden', 'true');
      el.appendChild(bar);
    });
  }

  var BMFx = {
    tweenText: tweenText,
    flash: flash,
    daysAgoText: daysAgoText
  };

  window.BMFx = BMFx;

  function init() {
    injectStyles();
    initSpotlights();
    initShimmers();
  }

  if (document) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  // Node unit tests
  if (typeof module !== 'undefined' && module.exports) module.exports = BMFx;
})(
  typeof window !== 'undefined' ? window : globalThis,
  typeof document !== 'undefined' ? document : null
);
